import "./Header.css";

export default function Header({ navItems = [], leftExtra, rightExtra, authSlot, onLogoClick }) {
  return (
    <header className="wc-header">
      <div className="wc-header-left">
        <div className="wc-header-logo" onClick={onLogoClick} style={onLogoClick ? { cursor: "pointer" } : undefined}>
          <img src="/logo.svg" alt="WSNCode" className="wc-header-logo-img" />
        </div>
        {navItems.length > 0 && (
          <nav className="wc-header-nav">
            {navItems.map((item, i) => (
              <button
                key={i}
                className={`wc-header-nav-link ${item.active ? "active" : ""}`}
                onClick={item.onClick}
              >
                {item.label}
              </button>
            ))}
          </nav>
        )}
        {leftExtra}
      </div>

      <div className="wc-header-right">
        {rightExtra}
        {authSlot}
      </div>
    </header>
  );
}
